import { getFeaturedPostsWidgetConfig } from '../../UserWidgets/FeaturedPosts/widgetConfig';
import { getPostsFeedWidgetConfig } from '../../UserWidgets/PostsFeed/widgetConfig';
import getCoverDeviationWidgetConfig from '../../UserWidgets/CoverDeviation/widgetConfig';

export const getPostsWidgetConfigs = ({ t, dispatch }) => ({
  coverDeviation: getCoverDeviationWidgetConfig({ t, dispatch }),
  postsFeed: getPostsFeedWidgetConfig({ t, dispatch }),
  featuredPosts: getFeaturedPostsWidgetConfig({ t, dispatch }),
});
